/**
 * Structural checks for a `LessonModule` body. Kept free of CodeMirror and React imports
 * so both editors (and Jest) can use it.
 */

export const VALID_CARD_TYPES = [
  // Steps
  'intro', 'insight', 'strategy', 'mentor', 'summary', 'challenge',
  'comic', 'mindmap', 'stats', 'reveal', 'voices', 'timeline',
  'reality_check', 'speaker', 'step_chat',
  // Tests
  'scenario', 'chat_simulator', 'story_mode', 'quick_fire',
  'before_after', 'drag_rank', 'swipe_test',
] as const;

export type CardType = typeof VALID_CARD_TYPES[number];

export function validateLessonBody(jsonStr: string): string | null {
  if (!jsonStr.trim()) return null;

  let parsed: any;
  try {
    parsed = JSON.parse(jsonStr);
  } catch (e) {
    return e instanceof Error ? e.message : 'Invalid JSON syntax.';
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return 'Body must be a JSON object.';
  }

  if (!Array.isArray(parsed.cards)) {
    return 'Body must have a "cards" array.';
  }

  for (let i = 0; i < parsed.cards.length; i++) {
    const card = parsed.cards[i];
    if (!card || typeof card !== 'object') {
      return `cards[${i}] must be an object.`;
    }
    if (!card.type) {
      return `cards[${i}] is missing the required "type" field.`;
    }
    if (!(VALID_CARD_TYPES as readonly string[]).includes(card.type)) {
      return `cards[${i}] has unknown type "${card.type}".`;
    }
  }

  return null;
}
